import {
  getUser,
  login as _login,
  logout as _logout,
  // eslint-disable-next-line prettier/prettier
  validateApplicationRole as _validateApplicationRole,
} from '@/core/auth';
import { clearCache, getAdditionalProfileInfo, getUserMenu } from '../api';
import types from './types';
import { USER_MENU_APP_SESSION_KEY } from '@/config';

export default {
  async init(context) {
    const { state, commit, dispatch } = context;
    try {
      const user = await getUser();
      commit(types.SET_USER, user);

      sessionStorage.setItem('user', JSON.stringify(user));

      if (user != null && state.userHasValidRole === null) {
        //Validate rol here
        const hasValidRole = await _validateApplicationRole().then((resp) => {
          return resp.data;
        });

        if (!hasValidRole) {
          await dispatch('logout');
          return;
        }

        commit(types.SET_USER_HAS_VALID_ROLE, hasValidRole);
        sessionStorage.setItem(
          'user-has-valid-role',
          JSON.stringify(hasValidRole)
        );
      }
      if (
        state.user &&
        (!state.userMenu || !state.companies || !state.permissions)
      ) {
        const [userMenu, additionalProfileInfo] = await Promise.all([
          await getUserMenu(),
          await getAdditionalProfileInfo(),
        ]);

        if (userMenu && userMenu.length) {
          //TODO We need valid this code:
          // const _filteredNav = response.data.filter((x) => {
          //   if (navMenu.Reports === x.id) {
          //     //eval report permission (temp solution)
          //     return getters.HasPermission('menu.reports.view');
          //   }
          //   return true;
          // });
          commit(types.SET_MENU, userMenu);
          sessionStorage.setItem(
            USER_MENU_APP_SESSION_KEY,
            JSON.stringify(userMenu)
          );
          sessionStorage.setItem('user-siteMap', JSON.stringify(userMenu));
          dispatch('$_common/getCurrentAcademicYear', null, {
            root: true,
          });
        }

        if (additionalProfileInfo) {
          const {
            companies,
            permissions,
            userProfile,
            healthRegions,
            serviceCenters,
          } = additionalProfileInfo;
          sessionStorage.setItem(
            'profile-update-flag',
            !userProfile.isProfileUpdated
          );
          //Set User Information
          commit(types.SET_PROFILE, userProfile);
          sessionStorage.setItem(
            'agreement-completed',
            userProfile.completeUserAgreement
          );
          //Set Companies
          commit(types.SET_COMPANIES, companies);
          sessionStorage.setItem('user-companies', JSON.stringify(companies));

          //Set Health Regions
          commit(types.SET_HEALTH_REGIONS, healthRegions);
          sessionStorage.setItem(
            'user-health-regions',
            JSON.stringify(healthRegions)
          );

          //Set Service centers
          commit(types.SET_SERVICE_CENTERS, serviceCenters);
          sessionStorage.setItem(
            'user-service-centers',
            JSON.stringify(serviceCenters)
          );

          commit(types.SET_PERMISSIONS, permissions);
          sessionStorage.setItem(
            'user-permissions',
            JSON.stringify(permissions)
          );
          commit(types.SET_SCHOOLS, userProfile.schools);

          // state.userProfile.permissions = profile.permissions;
          // state.userProfile.schools = profile.schools;
          sessionStorage.setItem('user-profile', JSON.stringify(state));
        }
      }
    } catch (e) {
      dispatch('clearSession');
    }
  },
  async clearSession({ commit }) {
    commit(types.SET_USER, null);
    commit(types.SET_MENU, null);
    commit(types.SET_PERMISSIONS, null);
    commit(types.SET_COMPANIES, null);
    commit(types.SET_HEALTH_REGIONS, null);
    commit(types.SET_USER_HAS_VALID_ROLE, null);
    sessionStorage.removeItem('user');
    sessionStorage.removeItem(USER_MENU_APP_SESSION_KEY);
    sessionStorage.removeItem('user-permissions');
    sessionStorage.removeItem('user-companies');
    sessionStorage.removeItem('user-health-regions');
    sessionStorage.removeItem('current-academic-year');
    sessionStorage.removeItem('user-has-valid-role');
    sessionStorage.removeItem('user-token');
    sessionStorage.removeItem('current-academic-year');
    sessionStorage.removeItem('student-history');
    sessionStorage.removeItem('user-is-Logging-out');
    sessionStorage.removeItem('selected-student');
    sessionStorage.removeItem('selected-student-details');
    sessionStorage.removeItem('show-selected-student');
    sessionStorage.removeItem('peiSelected');
    sessionStorage.clear();
    await clearCache();
  },
  login() {
    _login();
  },

  logout({ state, commit, dispatch }) {
    let logoutId = state.user.profile.sub;
    _logout();
    dispatch('clearSession').then(function() {
      //Remove Student Selected
      commit('$_student/clearSelectedStudent', true, { root: true });
      /* Señor FORCE */
      let urlLogout = process.env.VUE_APP_URL_AUTH;
      urlLogout += process.env.VUE_APP_ACR_URL_LOGOUT;
      urlLogout += '/?logoutid=' + logoutId;
      urlLogout +=
        '&redirectUrl=' + process.env.VUE_APP_URL_AUTH_POST_LOGOUT_REDIRECT_URI;
      window.location.replace(urlLogout);
    });
  },

  setMenu(context, menus) {
    context.commit(types.SET_MENU, menus);
    sessionStorage.setItem(USER_MENU_APP_SESSION_KEY, JSON.stringify(menus));
    sessionStorage.setItem('user-siteMap', JSON.stringify(menus));
  },
};
